/**
 * Created by Alican Köker
 * on 2018/02/19.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {WildNudgeGameConfig} from "../../WildNudgeGameConfig";

export class CommonWinAnimationView extends BaseView {

    private _reelBackgroundSteamLayer:PIXI.Container;
    private _steamAnimation:TimelineSprite;
    private _winAnimsTimeline:TimelineLite;
    private _isAnimPlaying:boolean = false;

    constructor() {
        super();
        this._reelBackgroundSteamLayer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.BACKGROUND_STEAM.name);
        this._winAnimsTimeline = new TimelineLite();
    }

    protected initAnimations():void {

        this._steamAnimation = new TimelineSprite(GameResources.getTextures("steam"));
        this._steamAnimation.position.set(15, 590);
        this._steamAnimation.pivot.set(this._steamAnimation.width / 2, this._steamAnimation.height / 2);
        this._steamAnimation.rotation = -90;
        this._steamAnimation.pivot.set(this._steamAnimation.width / 2, this._steamAnimation.height / 2);
        this._steamAnimation.blendMode = PIXI.BLEND_MODES.ADD;

        this._steamAnimation.hide();
        this._steamAnimation.stopLoop();

        this._reelBackgroundSteamLayer.addChild(this._steamAnimation);
    }

    public startWinSteamAnimations():void {
        if(!this._isAnimPlaying) {
            this._winAnimsTimeline = new TimelineLite();
            this._isAnimPlaying = true;
            this._winAnimsTimeline.add([
                () => this._steamAnimation.show(),
                () => this._steamAnimation.getAnimation().play(),
            ], 0.1);

            this._winAnimsTimeline.add(
                () => {this._isAnimPlaying = false;}
                , this._steamAnimation.getAnimation().duration());

            this._winAnimsTimeline.play();
        }
    }
}